import { log } from './LogHelper';

export class HealthKitSync {
  userId: number;

  constructor(userId: number) {
    this.userId = userId;
  }

  async authorize() {
    return await new Promise<boolean | undefined>(resolve => {
      resolve(false);
    });
  }

  async getDataToSynchronize(progress: (message: string) => void) {
    log('HealthKit no data to sync ');
    return [] as any[];
  }

  async getAuthStatus() {
    return await new Promise<boolean | undefined>(resolve => {
      resolve(false);
    });
  }
}
